module.exports = {"360722100":"嘉定镇","360722101":"大塘埠镇","360722102":"古陂镇","360722103":"大桥镇","360722104":"新田镇","360722105":"安西镇","360722106":"小江镇","360722107":"铁石口镇","360722108":"大阿镇","360722109":"油山镇","360722110":"小河镇","360722111":"西牛镇","360722112":"正平镇","360722200":"虎山乡","360722201":"崇仙乡","360722202":"万隆乡","360722400":"信丰县工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360722.json
// module id = 1402
// module chunks = 0